/*eslint-disable*/
import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, Row, Image } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import { api_gateway } from '../../../conexoes/api'
import '../../../css/painelDispositivos/dspCancelamentoReposicao/cancelamento.css'
import { revelarCancelamento } from '../../../redux/actions/index'
import {
  alertaAtencao,
  elipseVerde,
  fecharJanela
} from '../../../utils/alternanciaIcones'
import alertIcon from '../../../icones/iconesVersaoVerde/alert.svg'
import { revelarRealocacao } from '../../../redux/actions/index'
import RetornarParametro from '../../../utils/decryptJWT'
import { formatarMilhar } from '../../../utils/formatarMilhar'
import { identificarValidacaoAcoes } from '../../../utils/identificarValidacaoAcoes'

import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import TabelaGenerica from '../../componentesModais/tabela/tabela'
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'
import Card from '../../Mantine/Card'
import SimpleGrid from '../../Mantine/SimpleGrid'
import Divider from '../../Mantine/Divider'
import Select from '../../Mantine/Select'
import Input from '../../Mantine/Input'

import AlertaReposicao from './Alerta/reposicao.jsx'
import { useDisclosure } from '@mantine/hooks'
import Cancelamento from './Alerta/cancelamento.jsx'

let validacaoLinhas = false
let offset = 0
let valorTotal = 0.0
let valorTotalMulta = 0.0
let valorTaxaCancelamento = 0.0
let validacaoConcluida = false
let linhasValidas = false
let linhasInvalidas = false
let linhasRemovidas = []
let refazerCalculoValorTotal = true

const REASONS = [
  { value: 1, label: 'Sem projeção de crescimento', ADE_CODCAU: '00000049' },
  { value: 2, label: 'Cliente cancelado', ADE_CODCAU: '00000004' },
  { value: 3, label: 'Problema técnico', ADE_CODCAU: '00000045' },
  { value: 4, label: 'Preço', ADE_CODCAU: '00000006' },
  { value: 5, label: 'Política de cancelamento', ADE_CODCAU: '00000046' },
  { value: 6, label: 'Troca de fornecedor', ADE_CODCAU: '00000047' },
  { value: 7, label: 'Insatisfação com atendimento', ADE_CODCAU: '00000048' }
]

export default function CancelamentoReposicao(props) {
  const [spinAtivo, setSpinAtivo] = useState(true)
  const { handleSubmit } = useForm()
  const [dsMotivo, setDsMotivo] = useState(null)
  const [auxDsMotivo, setAuxDsMotivo] = useState('')
  const [itens, setItens] = useState([])
  const [revelarMensagemAtencaoInvalido, setRevelarMensagemAtencaoInvalido] =
    useState(false)
  const [revelarMensagemLinhasInvalidas, setRevelarMensagemLinhasInvalidas] =
    useState(true)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const [dsTelefone, setDsTelefone] = useState('')
  const [erroTelefone, setErroTelefone] = useState(true)

  const ADE_CODCAT = '00000001'
  const despacho = useDispatch()
  const modal = useRef()
  const codigoCliente = RetornarParametro('codigoClienteErpAntigo')

  let filtros = useSelector((state) => state.filtrosState.filtros)
  let buscaArquivo = useSelector(
    (state) => state.buscaArquivoState.buscaArquivo
  )
  let modoSelecaoSimcard = useSelector(
    (state) => state.manejadorState.modoSelecaoSimcard
  )
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let separadorLinha = useSelector(
    (state) => state.manejadorState.separadorLinha
  )
  const [revelarSelectMotivo, setRevelarSelectMotivo] = useState(false)
  const [numeroLinhasValidas, setNumeroLinhasValidas] = useState(-1)
  const [stringValorTotalMulta, setStringValorTotalMulta] = useState('')
  const [stringTaxaCancelamento, setStringTaxaCancelamento] = useState('')
  const [stringValorTotal, setStringValorTotal] = useState('')
  const taxaDeCancelamento = 10.0
  const valorLimite = 50
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [ordenador, setOrdenador] = useState('')
  const [fineValue, setFineValue] = useState('')
  const [taxaValue, setTaxaValue] = useState('')
  const [totalValue, setTotalValue] = useState('')
  const [
    openedAlertaReposicao,
    { open: openAlertaReposicao, close: closeAlertaReposicao }
  ] = useDisclosure(false)
  const darkTheme = localStorage.getItem('tema') === 'escuro'

  const regexTelefone =
    /^(?:\+?\d{1,3}\s?)?(\(?\d{2}\)?\s?)?\d{4,5}[-\s]?\d{4}$/
  const validarTelefone = (telefone) => {
    if (!telefone) return 'Informe o telefone para contato.'
    if (!regexTelefone.test(telefone)) return 'Telefone inválido.'
    return ''
  }

  const handleTelefone = (e) => {
    setDsTelefone(e)
    const erro = validarTelefone(e)
    setErroTelefone(erro)
  }

  /**Taxa de Cancelamento: é definido linhas pela constante
   * taxaDeCancelamento
   *
   * Multa de Cancelamento: é cobrado 50% do valor do plano mensal,
   * calculado utilizando a seguinte formula
   * (ValorPlano / 60 )*(dias restantes do contrato)
   * a divisao por 60 vem de o valor ser mensal, logo o valor diario é
   * adquirido dividindo o valor do plano por 30 e, como é cobrado 50%
   * deste valor, 50% = 1/2, X /30 /2 = X / 60
   */

  function handleCancelar() {
    ColetaClickstream(1086) // 'cancelamentoCancelar'
    validacaoLinhas = false
    offset = 0
    valorTotal = 0.0
    valorTotalMulta = 0.0
    valorTaxaCancelamento = 0.0
    validacaoConcluida = false
    linhasValidas = []
    linhasInvalidas = []
    linhasRemovidas = []
    refazerCalculoValorTotal = true
    setRevelarMensagemLinhasInvalidas(false)
    setSpinAtivo(false)
    despacho(revelarCancelamento(false))
  }

  function handleMotivo(motivo) {
    setRevelarSelectMotivo([6, 7].includes(motivo) ? true : false)
    setDsMotivo(motivo)
  }

  const handleAuxMotivo = (motivo) => {
    setAuxDsMotivo(motivo)
  }

  async function handleRemoverLinha(CD_SIMCARD) {
    ColetaClickstream(1085) // 'cancelamentoRemoverLinha'
    let position = false

    linhasValidas.map((item, i) => {
      if (item.CD_SIMCARD === CD_SIMCARD) {
        position = i
      }
    })

    if (!isNaN(position)) {
      linhasRemovidas.push(linhasValidas[position])
      linhasValidas.splice(position, 1)
      setNumeroLinhasValidas(linhasValidas.length)
      refazerCalculoValorTotal = true
    }
    if (linhasValidas.length < 1) {
      handleCancelar()
    }
    if (linhasValidas.length % 50 === 0) {
      setPaginaAtual(paginaAtual - 1)
    }
  }

  async function handleCalcularValorTotal() {
    setSpinAtivo(true)
    /**Calculo de multa chama a funcao calcular_multa do arquivo
     * back/src/controles/dispositivos/dspSimcard.js
     * do back-end e este envia uma query que rotorna o valor total da multa,
     * este valor é entao salvo na variavel valorTotalMulta
     */
    let linhasValidasAux = []
    await Promise.all(
      linhasValidas.map((item) => {
        linhasValidasAux.push(item.CD_SIMCARD)
      })
    )
    await api_gateway
      .post('/m1/consultar/simcard/calcular_multa', {
        codigoCliente: codigoCliente,
        linhasValidas: linhasValidasAux
      })
      .then(function (resposta) {
        valorTotalMulta = resposta.data.dados[0].VALOR_MULTA
        valorTaxaCancelamento = linhasValidas.length * taxaDeCancelamento
        valorTotal = valorTotalMulta + valorTaxaCancelamento
        setFineValue(valorTotalMulta)
        setTaxaValue(valorTaxaCancelamento)
        setTotalValue(valorTotal)
        produzirStringsValores()
        setSpinAtivo(false)
      })
      .catch(function () {
        setSpinAtivo(false)
        setMensagemErro('Erro ao calcular valores, favor tentar novamente!')
        setRevelarMensagemErro(true)
      })
  }

  const getColor = () => {
    return darkTheme ? '#FFF' : '#000'
  }

  const handleReplacement = () => {
    handleCancelar()
    despacho(revelarRealocacao(true))
  }

  const handleOpenAlertReplacement = () => {
    openAlertaReposicao()
  }

  function produzirStringsValores() {
    /**Converte os valores calculados para multa, taxa de cancelamento e
     * valor total para strings que serao exibidos na tela
     */
    if (valorTotalMulta != 0) {
      let multaString = formatarMilhar(valorTotalMulta)
      setStringValorTotalMulta(multaString)
    }
    if (valorTaxaCancelamento != 0) {
      let taxaDeCancelamentoString = formatarMilhar(valorTaxaCancelamento)
      setStringTaxaCancelamento(taxaDeCancelamentoString)
    }
    if (valorTotal != 0) {
      let valorTotalString = formatarMilhar(valorTotal)
      setStringValorTotal(valorTotalString)
    }
  }

  async function handleSalvar() {
    ColetaClickstream(1087) // 'cancelamentoConfirmar'
    setSpinAtivo(true)
    let temporario = new Date()
    let dataHora =
      temporario.toISOString().substring(0, 10) +
      ' ' +
      temporario.getHours() +
      ':' +
      temporario.getMinutes() +
      ':' +
      temporario.getSeconds()

    let linhasValidasAuxCDSIMCARD = []
    linhasValidas.map((item) => {
      linhasValidasAuxCDSIMCARD.push(item.CD_SIMCARD)
    })
    let linhasValidasAuxN0_MSISDN = []
    linhasValidas.map((item) => {
      linhasValidasAuxN0_MSISDN.push(item.CALLERID)
    })

    setSpinAtivo(true)
    const body = {
      fl_operadora: 0,
      simcards: linhasValidasAuxCDSIMCARD,
      FULLCALLERID: linhasValidasAuxN0_MSISDN,
      cd_crm_solicitacao_tipo: 2,
      cd_crm_solicitacao_status: 1,
      ds_crm_solicitacao: [6, 7].includes(dsMotivo)
        ? auxDsMotivo
        : REASONS.find((reason) => reason.value === dsMotivo).label,
      dt_inicio: dataHora,
      dt_fim: undefined,
      dt_previsao: undefined,
      ds_rota_permissao: 'veye/dispositivos/acoes/cancelamento',
      ADE_CODCAT: ADE_CODCAT,
      ADE_CODCAU: REASONS.find((reason) => reason.value === dsMotivo)
        .ADE_CODCAU,
      dsTelefone: dsTelefone,
      fineValue: fineValue,
      taxaValue: taxaValue,
      totalValue: totalValue
    }

    await api_gateway
      .post('/m1/cadastrar/solicitacao', body)
      .then(function () {
        setSpinAtivo(false)
        handleMensagemSucesso(false)
      })
      .catch(function () {
        setSpinAtivo(false)
        setMensagemErro('Erro na solicitação')
        handleMensagemErro(false)
      })
  }

  useEffect(() => {
    setSpinAtivo(true)
    offset = (paginaAtual - 1) * valorLimite
    async function carregarLinhas() {
      if (validacaoConcluida === false) {
        /**DURANTE A PRIMEIRA RENDERIZACAO DA MODAL, EXECUTA A VALIDACAO DAS LINHAS
         * REMOVENDO DA SOLICITACAO LINHAS QUE APRESENTEM BLOQUEIO DEVIDO A OUTRAS
         * SOLICITACOES
         */
        validacaoLinhas = await identificarValidacaoAcoes(
          props.itensSelecionados,
          2,
          { filtros, buscaArquivo },
          modoSelecaoSimcard,
          conteudoBusca,
          separadorLinha
        )
        linhasValidas = validacaoLinhas.itensValidos
        linhasInvalidas = validacaoLinhas.itensInvalidos
        setNumeroLinhasValidas(linhasValidas.length)
        validacaoConcluida = true
      }

      if (validacaoLinhas.itensValidos.length > 0) {
        if (refazerCalculoValorTotal === true) {
          handleCalcularValorTotal()
          refazerCalculoValorTotal = false
        }

        if (
          revelarMensagemLinhasInvalidas === true &&
          linhasInvalidas.length > 0 &&
          mensagemErro != 'Erro ao calcular valores, favor tentar novamente!'
        ) {
          handleRevelarMensagemLinhasInvalidas()
          setRevelarMensagemLinhasInvalidas(false)
        }

        let linhasValidasAux = []
        linhasValidas.map((item) => {
          linhasValidasAux.push(item.CD_SIMCARD)
        })
        let resposta = await api_gateway.post(
          '/m1/consultar/simcard/linhas_cancelamento',
          {
            linhasValidas: linhasValidasAux,
            offset: offset,
            ordenador: ordenador
          }
        )
        setItens(resposta.data.dados)

        setSpinAtivo(false)
      } else {
        if (linhasInvalidas.length > 0) {
          handleRevelarMensagemLinhasInvalidas()
          setRevelarMensagemLinhasInvalidas(false)
        } else {
          setMensagemErro('Todas as linhas selecionadas estão invalidas.')
          handleMensagemErro(false)
        }
      }
    }
    carregarLinhas()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginaAtual, linhasValidas.length, ordenador])

  function handleMensagemSucesso(confirmacao) {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      handleCancelar()
    }
    if (confirmacao) {
      props.setRenderizar(!props.renderizar)
    }
  }

  const handleFecharMensagemSucesso = () => {
    setRevelarMensagemSucesso(false)
    handleCancelar()
    props.setRenderizar(!props.renderizar)
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
      handleCancelar()
    }
  }

  function handleRevelarMensagemLinhasInvalidas() {
    setRevelarMensagemAtencaoInvalido(true)
  }

  function handleFecharMensagemItensInvalidos() {
    if (linhasValidas.length < 1) {
      handleCancelar()
    }
    setRevelarMensagemAtencaoInvalido(false)
  }

  const colunasItensInvalidos = [
    {
      dataField: 'CALLERID',
      text: 'Linha',
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-nao-permitidos">
            {cell != undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'ds_motivo',
      text: 'Motivo',
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-nao-permitidos">
            {cell != undefined ? cell : '-'}
          </p>
        )
      }
    }
  ]

  return (
    <Form ref={modal} onSubmit={handleSubmit(() => handleSalvar())}>
      <div className="modal-novo-cancelamento fundo-cor-6">
        {spinAtivo && (
          <div className="componente-spinner-overlay">
            <div className="componente-spinner-container">
              <SpinerVeye />
            </div>
          </div>
        )}
        <Form.Row className="margin-top-cancelamento">
          <Col>
            <img
              className="icone-label-janela nao-selecionavel"
              src={elipseVerde()}
              alt="elipse"
            />
            <Form.Label>
              <div className="fonte-cor-1 label-janela">Cancelamentos</div>
            </Form.Label>
            <Button
              className="botao-fechar-janela"
              variant="danger"
              onClick={() => handleCancelar()}
            >
              <img
                className="botao-fechar-janela-icone"
                src={fecharJanela()}
                alt="fechar-janela"
              />
            </Button>
          </Col>
        </Form.Row>
        {itens != '' && itens != undefined && itens != null && (
          <TabelaGenerica
            tabela="modalCancelamentoDispositivos"
            selecaoLinha={false}
            selecaoParque={false}
            selecaoPagina={false}
            expancaoLinha={false}
            colunaAcao="remover"
            ordenador={ordenador}
            setOrdenador={setOrdenador}
            itens={itens}
            paginaAtual={paginaAtual}
            setPaginaAtual={setPaginaAtual}
            limitePagina={valorLimite}
            totalItens={numeroLinhasValidas}
            setItemRemovido={handleRemoverLinha}
          />
        )}
        <Form.Row>
          <Col>
            <span className="fonte-cor-1 label-normal contador-linhas-acoes-dispositivos">
              {numeroLinhasValidas} linhas selecionadas
            </span>
          </Col>
        </Form.Row>

        {itens.length === 1 && (
          <Form.Row className="container-alert">
            <Col className="d-flex align-items-center">
              <div className="container-alert-icon">
                <Image className="alert-icon" src={alertIcon} />
              </div>
              <span style={{ color: getColor() }}>
                Você possui apenas 1 linha selecionada. Caso queira agilizar o
                processo, poderá fazer um cancelamento em lote selecionando
                várias linhas ao mesmo tempo.
              </span>
            </Col>
          </Form.Row>
        )}

        {(dsMotivo === '' ||
          dsTelefone === '' ||
          ([6, 7].includes(dsMotivo) && auxDsMotivo === '')) && (
          <div className="alert-fields" style={{ color: getColor() }}>
            *Campos obrigatórios
          </div>
        )}

        <Form.Group className="gap-row">
          <Row>
            <Col>
              <Select
                value={dsMotivo}
                onChange={(e) => {
                  handleMotivo(e)
                }}
                withAsterisk
                fontSize={18}
                label="Motivo"
                placeholder="Selecione"
                options={REASONS}
              />
            </Col>
            <Col>
              <Input
                withAsterisk
                fontSize={18}
                mask="(00) 000000000"
                label="Telefone para Contato"
                placeholder="Digite o telefone"
                value={dsTelefone}
                onChange={(e) => handleTelefone(e.target.value)}
              />
            </Col>
          </Row>
          {revelarSelectMotivo && (
            <Row>
              <Col>
                <Input
                  withAsterisk
                  placeholder="Descreva aqui o motivo"
                  value={auxDsMotivo}
                  maxLength={1000}
                  onChange={(e) => handleAuxMotivo(e.target.value)}
                />
              </Col>
            </Row>
          )}
        </Form.Group>

        <Form.Group>
          <Card>
            <SimpleGrid cols={3}>
              <div className="card-grid-detalhamento-valores">
                <div>
                  <div>
                    <b>Multa de contrato</b>
                  </div>
                  <div>
                    R${' '}
                    {stringValorTotalMulta?.trim() !== ''
                      ? stringValorTotalMulta?.trim()
                      : '0,00'}
                  </div>
                </div>
                <div className="card-grid-detalhamento-divider">
                  <Divider size="xs" marginY={0} orientation="vertical" />
                </div>
              </div>
              <div className="card-grid-detalhamento-valores">
                <div>
                  <div>
                    <b>Taxa de cancelamento</b>
                  </div>
                  <div>
                    R${' '}
                    {stringTaxaCancelamento?.trim() !== ''
                      ? stringTaxaCancelamento?.trim()
                      : '0,00'}
                  </div>
                </div>
                <div className="card-grid-detalhamento-divider">
                  <Divider
                    color="#CED4DA"
                    size="xs"
                    marginY={0}
                    orientation="vertical"
                  />
                </div>
              </div>
              <div>
                <div>
                  <b>Valor total</b>
                </div>
                <div className="total-value">
                  R${' '}
                  {stringValorTotal?.trim() !== ''
                    ? stringValorTotal?.trim()
                    : '0,00'}
                </div>
              </div>
            </SimpleGrid>
          </Card>
        </Form.Group>

        <Card radius="xl">
          Gostaria de evitar custos no cancelamento das suas linhas? Selecione a
          ação de{' '}
          <b>
            <span
              className="clickable-span"
              onClick={handleOpenAlertReplacement}
            >
              Reposição
            </span>
          </b>
          .
        </Card>

        <Form.Row>
          <Col>
            <div className="botoes-cancelamento">
              {dsMotivo !== null &&
              !erroTelefone &&
              (![6, 7].includes(dsMotivo) || auxDsMotivo?.trim() !== '') ? (
                <Button
                  type="submit"
                  className="botao-confirmar"
                  variant="success"
                  size="sm"
                >
                  <div className="fonte-cor-4">Confirmar</div>
                </Button>
              ) : (
                <Button className="botao-confirmar-desabilitado" size="sm">
                  <div className="fonte-cor-4">Confirmar</div>
                </Button>
              )}

              <Button
                className="botao-cancelar"
                variant="success"
                size="sm"
                onClick={() => handleCancelar()}
              >
                <div className="fonte-cor-2">Cancelar</div>
              </Button>
            </div>
          </Col>
        </Form.Row>
      </div>
      {revelarMensagemSucesso && (
        <Cancelamento
          opened={revelarMensagemSucesso}
          close={handleFecharMensagemSucesso}
        />
      )}
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemParagrafo1={mensagemErro}
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
      {revelarMensagemAtencaoInvalido && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <div className="modal-mensagem-atencao-acoes-simcards fundo-cor-6">
              <div className="mensagem-container-icone">
                <img
                  className="mensagem-icone"
                  src={alertaAtencao()}
                  alt="sucesso"
                />
              </div>
              <div className="fonte-cor-1 label-janela">
                {linhasInvalidas.length} linhas foram retiradas
              </div>
              <div className="container-tabela-modal-itens-nao-permitidos">
                <BootstrapTable
                  classes="tabela-transparente-modais"
                  keyField="ds_linha"
                  condensed
                  data={linhasInvalidas}
                  columns={colunasItensInvalidos}
                  noDataIndication={!spinAtivo && 'Nenhum item encontrado'}
                  bootstrap4
                />
              </div>
              <div className="mensagem-container-botao">
                <Button
                  className="mensagem-botao-cancelar"
                  variant="success"
                  size="sm"
                  onClick={() => handleFecharMensagemItensInvalidos()}
                >
                  <div className="fonte-cor-2">Cancelar</div>
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
      {openedAlertaReposicao && (
        <AlertaReposicao
          opened={openedAlertaReposicao}
          onClick={() => handleReplacement()}
          close={() => closeAlertaReposicao()}
        />
      )}
    </Form>
  )
}
